import React from 'react';
import StorageYardMaterialReceiptsScreen from './screens/StorageYardMaterialReceiptsScreen';

export default function StorageYardMaterialReceipts() {
  return <StorageYardMaterialReceiptsScreen />;
}
